import { createSelector } from 'reselect'

const retailerSelector = (state) =>
  (state.retailers && state.retailers.retailers) || []
const seatTableRetailerSelector = (state) =>
  (state.retailers && state.retailers.seatTableRetailers) || null
const seatTableRetailerTotalSelector = (state) =>
  (state.retailers && state.retailers.seatTableRetailersTotal) || null
const seatTableRetailerFilteredTotalSelector = (state) =>
  (state.retailers && state.retailers.seatTableRetailersFilteredTotal) || null
const seatTableParametersSelector = (state) =>
  (state.retailers && state.retailers.seatTableParameters) || null
const getSeatBrandRetailersBulkGetResponseSelector = (state) =>
  (state.retailers && state.retailers.getSeatBrandRetailersBulkGetResponse) ||
  null
const getFacebookPagesSelector = (state) => state.facebookPages || null

export const retailersByIdSelector = createSelector(
  [retailerSelector],
  (retailers) => {
    return retailers.reduce((accumulator, retailer) => {
      accumulator[retailer.id] = retailer
      return accumulator
    }, {})
  },
)

export const selectRetailersById = createSelector(
  [retailersByIdSelector],
  (retailersById) => ({
    retailersById,
  }),
)

export const selectRetailers = createSelector(
  [retailerSelector],
  (retailers) => {
    return { retailers }
  },
)

export const selectSeatTableRetailers = createSelector(
  [seatTableRetailerSelector],
  (seatTableRetailers) => {
    return { retailers: seatTableRetailers }
  },
)

export const selectSeatTableRetailersIds = createSelector(
  [seatTableRetailerSelector],
  (seatTableRetailers) => {
    return {
      retailerIds:
        seatTableRetailers && seatTableRetailers.map((retailer) => retailer.id),
    }
  },
)

export const selectSeatTableRetailersTotal = createSelector(
  [seatTableRetailerTotalSelector],
  (seatTableRetailersTotal) => {
    return { retailersTotal: seatTableRetailersTotal }
  },
)

export const selectSeatTableRetailersFilteredTotal = createSelector(
  [seatTableRetailerFilteredTotalSelector],
  (seatTableRetailersFilteredTotal) => {
    return { retailersFilteredTotal: seatTableRetailersFilteredTotal }
  },
)

export const selectSeatTableParameters = createSelector(
  [seatTableParametersSelector],
  (seatTableParameters) => {
    return { seatTableParameters }
  },
)

export const selectGetSeatBrandRetailersBulkGetResponse = createSelector(
  [getSeatBrandRetailersBulkGetResponseSelector],
  (getSeatBrandRetailersBulkGetResponse) => {
    return { getSeatBrandRetailersBulkGetResponse }
  },
)

export const selectFacebookPages = createSelector(
  [getFacebookPagesSelector],
  (facebookPages) => {
    return {
      facebookPages,
    }
  },
)
